import React, { useRef, useEffect } from "react";
import { Html } from "@react-three/drei";
import { types } from "@theatre/core";
import { useSheet, useObject, useObjectCallback } from "../../hooks/useTheatre";
import useAnalyticsEventTracker from "../../hooks/useAnalyticsEventTracker";
import { useTranslation } from "react-i18next";
import useLevel from "../../hooks/useLevel";
import { useSpring, animated, config } from "@react-spring/web";
import { useSnapshot } from "valtio";
import store from "../../appStore";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useSynchronizedState } from "@solidwhite/multiuser";

const animationConfig = {
  LineFadeIn: types.number(1, {
    range: [0, 20],
    nudgeMultiplier: 0.1,
  }),
  BorderWidth: types.number(1, {
    range: [0, 2],
    nudgeMultiplier: 0.1,
  }),
  Opacity: types.number(1, {
    range: [0, 1],
    nudgeMultiplier: 0.05,
  }),
};

const Hotspot = ({ id, position = [0, 0, 0], onClick = (e) => {}, ...props }) => {
  // const sheet = useSheet("EFD", "Hotspot", `Label_${id}`);
  // const animationValues = useObject(sheet, "Hotspot", animationConfig);
  const line = useRef();
  const border = useRef();
  const gaEventTracker = useAnalyticsEventTracker("Hotspots");
  const { t } = useTranslation();
  const [currentLevel] = useLevel();

  const [hovered, setHovered] = useSynchronizedState(`label_hover_${props.text}`, false);

  // useObjectCallback(sheet, "Hotspot", animationConfig, (values) => {
  //   if (line.current !== undefined && line.current !== null) {
  //     // line.current.style.height = values.LineFadeIn;
  //     // border.current.style.boxShadow = `0px 0px 0px ${values.BorderWidth}px #fff`;
  //     border.current.style.opacity = values.Opacity;
  //     line.current.style.height = `${values.LineFadeIn * 100}%`;
  //     // console.log(border.current.style.boxShadow);
  //     // console.log(line.current.style.height);
  //   }
  // });

  // useEffect(() => {
  //   sheet.sequence.position = 0;
  //   var timeout = setTimeout(
  //     () => {
  //       sheet.sequence.play({
  //         // iterationCount: 1,
  //       });
  //     },
  //     props.delay ? props.delay : 200
  //   );

  //   return () => {
  //     sheet.sequence.position = 0;
  //     sheet.sequence.pause();
  //     clearTimeout(timeout);
  //   };
  // }, []);

  const { faded } = useSnapshot(store);

  const { opacity } = useSpring({
    from: { opacity: 0 },
    to: { opacity: faded ? 0 : 1 },
    delay: props.delay ? props.delay : 200,
    config: config.slow,
    opacity: faded ? 0 : 1,
  });

  useEffect(() => {
    setHovered(false);
  }, [faded]);

  const hoverSpring = useSpring({
    opacity: hovered ? 0.8 : 0,
  });

  return (
    <group position={position} layers={[0]}>
      <Html style={{ pointerEvents: "none", transform: "translate(-50%, -100%)" }} zIndexRange={[9998, 0]} layers={[0]}>
        <animated.div style={{ opacity: opacity }}>
          <div
            style={{
              // overflow: "hidden",
              // width: props.style ? props.style.width : "100%",
              // opacity: props.style ? props.style.opacity : 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              pointerEvents: "all",
            }}
            onPointerOver={() => setHovered(true)}
            onPointerLeave={() => setHovered(false)}
          >
            <animated.div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "3px",
                // border: "5px solid #deffef",
                background: "#deffef",
                zIndex: -5,
                // transform: "translate(-5px,-5px)",
                opacity: hoverSpring.opacity,
                boxShadow: "0 0 25px 5px #37a46e",
              }}
            ></animated.div>

            <div
              ref={border}
              onClick={(e) => {
                onClick(e);
                currentLevel > 1 && gaEventTracker(`${t(props.text)} click`);
              }}
              onPointerOver={props.onPointerOver ? props.onPointerOver : () => {}}
              onPointerOut={props.onPointerOut ? props.onPointerOut : () => {}}
              style={{
                color: "#000",
                textAlign: "center",
                width: "max-content",
                fontSize: "0.9vw",
                fontWeight: 500,
                padding: "0.75vw",
                paddingLeft: props.isAnimation ? "0.5vw" : "0.75vw",
                paddingTop: "0.5vw",
                paddingBottom: "0.5vw",
                pointerEvents: "auto",
                transition: "boxShadow 0.9s linear",
                borderRadius: "3px",
                cursor: "pointer",
                opacity: 1,
                backgroundColor: "#37a46e",
                display: "flex",
                alignItems: "center",
              }}
            >
              {props.isAnimation && (
                <PlayArrowIcon
                  style={{
                    paddingRight: "0.5vw",
                    width: "1.25vw",
                    height: "1.25vw",
                  }}
                />
              )}
              {props.text}
            </div>

            {/* <div
              style={{
                height: "1vw",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <div
                style={{
                  width: "2px",
                  height: "75%",
                  backgroundColor: "transparent",
                }}
                ref={line}
              ></div>
            </div> */}

            {/* <svg
            ref={line}
            style={{
              // height:
              //   animationValues !== undefined ? animationValues.LineFadeIn : 0,
            }}
            width="2"
          >
            <line
              x1="0"
              y1="0"
              x2="0"
              y2="20"
              fill="none"
              stroke="#fff "
              strokeWidth={4}
              strokeDasharray={240}
            />
          </svg> */}
          </div>
        </animated.div>
      </Html>
    </group>
  );
};

export default Hotspot;
